module.exports = "<router-outlet>\r\n</router-outlet>"